<template>
    <div class="container">
        <div v-if="isInCpcnWhite === 1">
            <div>扫码支付管理</div>
            <div class="scan-code-wrapper">
                <div v-for="(item,index) in scanCodePayData" :key="index" class="scan-code-content">
                    <img :src="item.icon" alt="" :style="{ 'width': index === 1 ? '102px' : '136px' }">
                    <div class="tip margin-t4" v-if="item.switchFlag && !item.applyStatus" style="margin-top: 4px">未开通</div>
                    <div class="tip" v-if="item.switchFlag && item.applyStatus === '20'">待审核</div>
                    <div class="tip "
                         v-if="(item.applyStatus === '30' || item.applyStatus === '40') && item.switchFlag">待授权
                    </div>
                    <div class="tip " v-if="item.switchFlag === 0">已开通</div>
                    <div class="tip" v-if="item.applyStatus === '50'" style="margin-top: 4px">开通失败
                        <el-tooltip class="item" effect="dark" :content="item.responseMessage" placement="top" v-if="item.responseMessage">
                            <i class="el-icon-warning-outline"/>
                        </el-tooltip>
                    </div>
                    <div class="handle-scan-code" @click="handleOpening(item.payWay,item.switchFlag,item.applyStatus)"
                         v-if="applyOpening(item)">
                        申请开通
                    </div>
                    <div class="handle-scan-code" @click="initiateAuthorization(item.payWay,item.switchFlag)"
                         v-if="(item.applyStatus === '30' || item.applyStatus === '40') && item.switchFlag">
                        申请实名认证
                    </div>
                </div>
            </div>
        </div>
        <no-permission  v-if="isInCpcnWhite === 2"/>

<!--        <opening-code-type-dialog :dialogTitle="dialogTitle" :visible="visible" :payWay="payWay"-->
<!--                                  @closeDialog="closeDialog" @openCodeCollection="openCodeCollection" v-if="visible"/>-->
    </div>

</template>

<script>
    import api from "../../api/order";
    import payApi from "../../api/pay/index";
    // import openingCodeTypeDialog from './common/openingCodeTypeDialog'
    import noPermission from '../../components/pay/noPermission';
    export default {
        name: "index",
        components: {noPermission},
        data() {
            return {
                isInCpcnWhite:3,//1 是有白名单，2是没有
                companyId: '',
                scanCodePayData: [
                    {icon: require('@/assets/img/pay/wechat-icon.png'), switchFlag: 1, payWay: 10,applyStatus:null,responseMessage:''},//微信  开关标志 0、开启 1、关闭    applyStatus 20审核中 40 成功 50 失败
                    {icon: require('@/assets/img/pay/alipay-icon.png'), switchFlag: 1, payWay: 20,applyStatus:null,responseMessage:''},//支付宝  开关标志 0、开启 1、关闭
                ],
                payWay: 0,//微信 10 ；支付宝 20
             }
        },
        methods: {
          //申请开通 增加校验
          applyOpening(item) {
            if ((item.switchFlag && !item.applyStatus) || item.applyStatus === '50') {
              return true;
            }
            if (item.switchFlag && item.applyStatus === '20') {
              return true;
            }
            return false;
          },
            //发起授权
            initiateAuthorization(payWay){
                this.$router.push({ path: "/openingCollection",query:{payWay: payWay,activeStep:2} })
            },
            //申请开通或注销  开关标志 0、开启 1、关闭
          handleOpening(payWay, switchFlag, applyStatus) {
                if (switchFlag) {//现在关闭 申请开通
                  if (applyStatus === '20') {
                    this.$router.push({path: "/openingCollection", query: {payWay: payWay, activeStep: 2}})
                  } else {
                    this.$router.push({path: "/openingCollection", query: {payWay: payWay, activeStep: 1}})
                  }
                }
            },
            async queryScanCodeApplyStatus(type) {
                let params = {
                    companyId: this.companyId,
                    payWay: type === 'wechat'? 10 :20,
                }
                let res = await api.queryScanCodeApplyStatus(params);
                if (res.code === "200") {
                    //开关标志 0、开启 1、关闭
                    if (type === 'wechat') {
                        this.scanCodePayData[0].switchFlag = res.data.switchFlag;
                        this.scanCodePayData[0].applyStatus = res.data.applyStatus;
                        this.scanCodePayData[0].responseMessage = res.data.responseMessage ? res.data.responseMessage :'';
                    } else {
                        this.scanCodePayData[1].switchFlag = res.data.switchFlag;
                        this.scanCodePayData[1].applyStatus = res.data.applyStatus;
                        this.scanCodePayData[1].responseMessage = res.data.responseMessage ? res.data.responseMessage :'';

                    }
                }
             },
            queryBothAuthority() {
                this.queryScanCodeApplyStatus('wechat');
                setTimeout(() => {
                    this.queryScanCodeApplyStatus('alipay');
                }, 10)
            },
          async isInCpcnWhiteList(){
            let res = await payApi.isInCpcnWhiteList();
            if (res.success) {
              if(res.data){
                this.isInCpcnWhite = 1;
                this.companyId = JSON.parse(localStorage.getItem('USERINFO')).companyId;
                this.queryBothAuthority();
              }else{
                this.isInCpcnWhite = 2;
              }
            }
          },
        },
        mounted() {
          this.isInCpcnWhiteList();
        }
    }
</script>

<style scoped lang="scss">
    .scan-code-wrapper {
        margin-top: 20px;
        display: flex;
        .scan-code-content {
            width: 260px;
            height: 128px;
            border: 1px solid #DCDCDC;
            display: flex;
            padding: 20px;
            flex-direction: column;
            align-items: center;
            margin-right: 30px;

            img {
                height: 30px;
            }

            .tip {
                margin-top: 10px;
                margin-bottom: 10px;
                font-size: 14px;
                color: #333;
            }
            .margin-t4{
                margin-top: 4px;
            }
            .margin-t10{
                margin-top: 10px;
            }

            .handle-scan-code {
                cursor: pointer;
                color: #2587FF;
                padding: 6px 15px;
                background: #fff;
                font-size: 12px;
                border: 1px solid #2587FF;
            }
        }
    }

</style>